import React from 'react'

function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16">
      <path
        fill="#0AA1F4"
        d="M9.333 9.501v1.394A4.001 4.001 0 004 14.667H2.667A5.333 5.333 0 019.332 9.5zM8 8.667c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm0-1.334A2.666 2.666 0 108 2a2.666 2.666 0 100 5.333zm4 4v-2h1.333v2h2v1.334h-2v2H12v-2h-2v-1.334h2z"
      ></path>
    </svg>
  )
}

export default Icon
